var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cardToContentCollectionCard } from "contentCollection/cardMapping";
import React from "react";
import { Hero } from "./components/Hero";
import { Highlight } from "./components/Highlight";
import { PageGrid } from "./components/grid";
export var View = function (_a) {
    var _b;
    var data = _a.data;
    if (!data || (data.tickets.length === 0 && !data.experienceHighlights)) {
        return null;
    }
    var experienceAsTickets = (_b = data.experienceHighlights) === null || _b === void 0 ? void 0 : _b.items.map(function (item) {
        var card = cardToContentCollectionCard(item);
        if (card.kind === "Basic" ||
            card.kind === "Labeled" ||
            card.kind === "Video") {
            return __assign(__assign({}, item), { url: card.slug });
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Hero, null),
        data.tickets && (React.createElement(React.Fragment, null,
            React.createElement(Highlight, { ticket: data.tickets[0] }),
            React.createElement(PageGrid, { title: "Tickets", tickets: data.tickets.slice(1) }))),
        data.experienceHighlights && (React.createElement(React.Fragment, null,
            React.createElement(Highlight, { ticket: experienceAsTickets[0], altCta: 'Schrijf je in' }),
            React.createElement(PageGrid, { title: "Doe mee", tickets: experienceAsTickets.slice(1) })))));
};
